import React, { useState } from 'react';
import { Search, Shield, Filter } from 'lucide-react';
import { packages } from '../data/mockData';
import PackageCard from '../components/PackageCard';
import PackageDetailModal from '../components/PackageDetailModal';

const CATEGORIES = [
  { id: 'all', label: 'Semua' },
  { id: 'ramadan', label: 'Ramadan' },
  { id: 'regular', label: 'Reguler' },
  { id: 'vip', label: 'VIP' },
  { id: 'keluarga', label: 'Keluarga' },
];

export default function Beranda() {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedPackage, setSelectedPackage] = useState(null);

  const filtered = packages.filter(pkg => {
    const matchSearch = !search ||
      pkg.name.toLowerCase().includes(search.toLowerCase()) ||
      pkg.provider.toLowerCase().includes(search.toLowerCase());
    const matchCat = activeCategory === 'all' || pkg.category === activeCategory;
    return matchSearch && matchCat;
  });

  return (
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold dark:text-white text-[#1A202C] mb-1">
          Marketplace Paket Umroh
        </h2>
        <p className="text-sm dark:text-gray-400 text-gray-500">
          {packages.length} paket dari travel agent terverifikasi
        </p>
      </div>

      {/* Search + Filter */}
      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <div className="relative flex-1">
          <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 dark:text-gray-500 text-gray-400" />
          <input
            data-testid="search-packages-input"
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Cari nama paket atau travel agent..."
            className="w-full pl-11 pr-4 py-3 rounded-xl text-sm border outline-none transition-colors focus:border-[#00C9B1] dark:bg-[#1A1A24] dark:border-[#2D3748] dark:text-white dark:placeholder-gray-600 bg-white border-[#E2E8F0] text-[#1A202C] placeholder-gray-400"
          />
        </div>
        <button
          data-testid="filter-btn"
          className="flex items-center gap-2 px-4 py-3 rounded-xl border dark:border-[#2D3748] border-[#E2E8F0] dark:text-gray-400 text-gray-500 dark:hover:border-[#00C9B1]/40 hover:border-[#00C9B1]/40 transition-colors text-sm"
        >
          <Filter size={16} />
          <span>Filter</span>
        </button>
      </div>

      {/* Category Tabs */}
      <div className="flex gap-2 overflow-x-auto pb-2 mb-6 scrollbar-hide">
        {CATEGORIES.map(cat => (
          <button
            key={cat.id}
            data-testid={`category-tab-${cat.id}`}
            onClick={() => setActiveCategory(cat.id)}
            className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap transition-all flex-shrink-0 ${
              activeCategory === cat.id
                ? 'bg-[#00C9B1] text-[#0E0E12]'
                : 'dark:bg-[#1A1A24] bg-white dark:border dark:border-[#2D3748] border border-[#E2E8F0] dark:text-gray-400 text-gray-500 dark:hover:border-[#00C9B1]/30 hover:border-[#00C9B1]/30'
            }`}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Trust Banner */}
      <div className="mb-6 p-4 rounded-2xl bg-gradient-to-r from-[#00C9B1]/10 to-[#F5A623]/5 border border-[#00C9B1]/15 flex items-center gap-4">
        <div className="w-10 h-10 rounded-xl bg-[#00C9B1]/15 flex items-center justify-center flex-shrink-0">
          <Shield size={20} className="text-[#00C9B1]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold dark:text-white text-[#1A202C]">Rekomendasi Terpercaya</p>
          <p className="text-xs dark:text-gray-400 text-gray-500">Semua paket dilindungi Smart Escrow. Dana aman hingga perjalanan selesai.</p>
        </div>
        <div className="hidden sm:flex items-center gap-2 text-xs dark:text-gray-400 text-gray-500 flex-shrink-0">
          <Shield size={12} className="text-[#F5A623]" />
          <span className="text-[#F5A623] font-medium">OJK Berlisensi</span>
        </div>
      </div>

      {/* Results count */}
      {search && (
        <p className="text-sm dark:text-gray-400 text-gray-500 mb-4">
          Menampilkan {filtered.length} hasil untuk "<span className="text-[#00C9B1]">{search}</span>"
        </p>
      )}

      {/* Package Grid */}
      {filtered.length > 0 ? (
        <div data-testid="packages-grid" className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
          {filtered.map(pkg => (
            <PackageCard key={pkg.id} pkg={pkg} onViewDetail={setSelectedPackage} />
          ))}
        </div>
      ) : (
        <div data-testid="no-results" className="text-center py-16">
          <Search size={40} className="mx-auto dark:text-gray-600 text-gray-300 mb-4" />
          <p className="dark:text-gray-400 text-gray-500 font-medium">Tidak ada paket ditemukan</p>
          <p className="text-sm dark:text-gray-600 text-gray-400 mt-1">Coba kata kunci lain</p>
        </div>
      )}

      {/* Package Detail Modal */}
      {selectedPackage && (
        <PackageDetailModal
          pkg={selectedPackage}
          isAuthenticated={true}
          onClose={() => setSelectedPackage(null)}
        />
      )}
    </div>
  );
}
